export enum CustomElementsEnum {
  ASSETS_TREE_BODY = 'assets-tree-body',
  CREATE_OR_EDIT_PENDENCY_BODY = 'create-or-edit-pendency-body',
  EQUIPMENT_WITH_WARRANTIES = 'equipment-with-warranties',
  FC_MAINTENANCE_SELECT = 'fc-maintenance-select',
  FC_SELECT_MULTIPLE_PAGED = 'fc-select-multiple-paged',
  FC_SELECT_PAGED = 'fc-select-paged',
  FC_TOOLBAR = 'fc-toolbar',
  MAINTENANCE_PRODUCTS_TAB = 'maintenance-products-tab',
  MAINTENANCE_SERVICES_TAB = 'maintenance-services-tab',
  UPDATE_PENDENCY_ASSIGNEE_MODAL_BODY = 'update-pendency-assignee-modal-body',
  WARRANTIES_MAINTENANCE_TAB = 'warranties-maintenance-tab'
}
